import React, { useState, useEffect } from "react";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle.tsx";
import Infosquare from "../../InfoSquare/Infosquare";
import "./dashboard.css";
import Inforetangle from "../../InfoRetangle/Inforetangle";
import { useNotification } from "../../../hooks/useNotification";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { BoardData } from "../../../interfaces/ISettings.tsx";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { Box, Grid } from "@mui/material";

const periodOptions: string[] = ["weekly", "monthly", "today", "last30days"];

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ["Parceiros", "Suporte"],
  datasets: [
    {
      label: "Chamados Abertos",
      data: [12, 19],
      backgroundColor: ["rgba(216, 17, 89)", "rgba(25, 42, 81)"],
    },
  ],
};

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom" as const,
    },
    title: {
      display: true,
      text: "Chamados Abertos",
    },
  },
  maintainAspectRatio: false,
};

function Dashboard() {
  const { notify } = useNotification();
  const { loading, getDashboardData } = useApiRequests();

  const [boardData, setBoardData] = useState<BoardData | null>(null);
  const [period, setPeriod] = useState<string>("weekly");

  useEffect(() => {
    const fetchData = async () => {
      const data = await getDashboardData(period);
      if (data.success) {
        setBoardData(data.data);
      } else {
        notify(data.msg, { type: "warning" });
      }
    };

    fetchData();
  }, [period]);

  return (
    <div className="page-container">
      <Title>Dashboard</Title>
      <SubTitle>
        <UncontrolledButtonDropdown setActiveFromChild>
          <DropdownToggle
            caret
            className="nav-link pointer filter filter-opacity"
            tag="a"
          >
            {period === "weekly"
              ? "Últimos 7 dias"
              : period === "monthly"
              ? "Mês atual"
              : period == "last30days"
              ? "Últimos 30 dias"
              : "Hoje"}
          </DropdownToggle>
          <DropdownMenu>
            {periodOptions?.map((option) => (
              <DropdownItem
                tag="a"
                key={option}
                onClick={() => {
                  setPeriod(option);
                }}
              >
                {option === "weekly"
                  ? "Últimos 7 dias"
                  : option === "monthly"
                  ? "Mês atual"
                  : option == "last30days"
                  ? "Últimos 30 dias"
                  : "Hoje"}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      </SubTitle>
      <div className="page-data-container d-flex flex-column gap-5">
        <div className="d-flex mt-5 gap-3 flex-wrap">
          <Infosquare
            title="Criados"
            data={boardData?.Created || 0}
            loading={loading}
            type={1}
          />
          <Infosquare
            title="Parceiros"
            data={boardData?.FromApi || 0}
            loading={loading}
            type={1}
          />
          <Infosquare
            title="Concluídos"
            data={boardData?.Validated || 0}
            loading={loading}
            type={1}
          />
          <Infosquare
            title="Reprovados"
            data={boardData?.Reproved || 0}
            loading={loading}
            type={1}
          />
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1}>
            {/* <Grid
              style={{
                maxHeight: "12.5rem",
                width: "fit-content",
                padding: "1rem",
                marginRight: "1rem",
                borderRadius: "8px",
                border: "1px solid #EDEDED",
              }}
              className="shadow-sm"
            >
              <Pie data={data} options={options} />
            </Grid> */}
            <Grid>
              <Infosquare

                title="Equipe"
                data={boardData?.ProductivityPercentage || 0}
                loading={loading}
                type={2}
              />
            </Grid>
            <Grid style={{marginLeft: "1rem", border:"none", outline:"none"}}>
              <Infosquare
                title="Erros"
                data={boardData?.PublishDays || 0}
                loading={loading}
                type={3}
              />
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  );
}

export default Dashboard;
